export class DTO_STATE {
}
DTO_STATE.DTO_NEW = 'DTO_NEW';
DTO_STATE.DTO_MODIFIED = 'DTO_MODIFIED';
DTO_STATE.DTO_DELETED = 'DTO_DELETED';
DTO_STATE.DTO_UNCHANGED = 'DTO_UNCHANGED';
export var IS_DELETED;
(function (IS_DELETED) {
    IS_DELETED[IS_DELETED["ACTIVE"] = 0] = "ACTIVE";
    IS_DELETED[IS_DELETED["IN_ACTIVE"] = 1] = "IN_ACTIVE";
})(IS_DELETED || (IS_DELETED = {}));
export var UNIT_OF_WEIGHT;
(function (UNIT_OF_WEIGHT) {
    UNIT_OF_WEIGHT["PCS"] = "PCS";
    UNIT_OF_WEIGHT["G"] = "G";
})(UNIT_OF_WEIGHT || (UNIT_OF_WEIGHT = {}));
// TODO: need to refactor UNIT_OF_WEIGHT and UNITS into One enum or struct
export var UNITS;
(function (UNITS) {
    UNITS["PCS"] = "PCS";
    UNITS["M"] = "M";
    UNITS["NEW"] = "";
})(UNITS || (UNITS = {}));
const UNIT_LABELS = {
    [UNITS.PCS]: "PCS",
    [UNITS.M]: "Meter",
    [UNITS.NEW]: "",
};
export var FIELD_NAMES;
(function (FIELD_NAMES) {
    FIELD_NAMES["NAME"] = "NAME";
    FIELD_NAMES["DESCRIPTION"] = "DESCRIPTION";
})(FIELD_NAMES || (FIELD_NAMES = {}));
export var ORDER_STAGES;
(function (ORDER_STAGES) {
    ORDER_STAGES[ORDER_STAGES["NEW"] = 0] = "NEW";
    ORDER_STAGES[ORDER_STAGES["PREPAID"] = 1] = "PREPAID";
    ORDER_STAGES[ORDER_STAGES["CANCELED"] = 2] = "CANCELED";
    ORDER_STAGES[ORDER_STAGES["DONE"] = 3] = "DONE";
    ORDER_STAGES[ORDER_STAGES["PICKED_UP"] = 4] = "PICKED_UP";
})(ORDER_STAGES || (ORDER_STAGES = {}));
export const ORDER_STAGES_LABELS = {
    [ORDER_STAGES.NEW]: "NEW",
    [ORDER_STAGES.PREPAID]: "PREPAID",
    [ORDER_STAGES.CANCELED]: "CANCELED",
    [ORDER_STAGES.DONE]: "DONE",
    [ORDER_STAGES.PICKED_UP]: "PICKED_UP",
};
export const ORDER_SOURCES = ['INSTAGRAM', 'FACEBOOK', 'WHATSAPP', 'PHONE'];
export const RECIPE_SIZE = [
    '0.10',
    '0.20',
    '0.25',
    '0.30',
    '0.33',
    '0.40',
    '0.50',
    '0.60',
    '0.66',
    '0.70',
    '0.75',
    '0.80',
    '0.90',
    '1.00',
    '1.10',
    '1.20',
    '1.25',
    '1.30',
    '1.33',
    '1.40',
    '1.50',
    '1.60',
    '1.66',
    '1.70',
    '1.75',
    '1.80',
    '1.90',
    '2.00',
    '2.10',
    '2.20',
    '2.25',
    '2.30',
    '2.40',
    '2.50',
    '2.60',
    '2.70',
    '2.75',
    '2.80',
    '2.90',
    '3.00',
    '3.10',
    '3.20',
    '3.25',
    '3.30',
    '3.40',
    '3.50',
    '3.60',
    '3.70',
    '3.75',
    '3.80',
    '3.90',
    '4.00',
    '4.10',
    '4.20',
    '4.25',
    '4.30',
    '4.40',
    '4.50',
    '4.60',
    '4.70',
    '4.75',
    '4.80',
    '4.90',
    '5.00',
    // '5.25',
    // '5.50',
    // '5.75',
    // '6.00',
    // '6.25',
    // '6.50',
    // '6.75',
    // '7.00',
    // '7.25',
    // '7.50',
    // '7.75',
    // '8.00',
    // '8.25',
    // '8.50',
    // '8.75',
    // '9.00',
    // '9.25',
    // '9.50',
    // '9.75',
    // '10.00',
];
export const RECIPE_SIZE_SPECIAL = [
    '0.25',
    '0.33',
    '0.50',
    '0.66',
    '0.75',
    '1.00',
    '1.25',
    '1.33',
    '1.50',
    '1.66',
    '1.75',
    '2.00',
    '2.25',
    '2.50',
    '2.75',
    '3.00',
    '3.25',
    '3.50',
    '3.75',
    '4.00',
    '4.25',
    '4.50',
    '4.75',
    '5.00',
    // '5.25',
    // '5.50',
    // '5.75',
    // '6.00',
    // '6.25',
    // '6.50',
    // '6.75',
    // '7.00',
    // '7.25',
    // '7.50',
    // '7.75',
    // '8.00',
    // '8.25',
    // '8.50',
    // '8.75',
    // '9.00',
    // '9.25',
    // '9.50',
    // '9.75',
    // '10.00',
];
export const CLEAR_BUTTON = 'InputAdornment-IconButton-SearchOffIcon-ff#11@!';
export class FIELDS {
}
FIELDS.COMMON = {
    CANCEL: 'cancel',
    CONFIRM: 'confirm',
    CREATE: 'create',
    YES: 'yes',
    NO: 'no',
    SOCIAL_MEDIA_PROFILE: 'social_media_profile',
    AT: 'at',
    ALREADY_EXISTS: 'already_exists',
    SAVE: 'save',
    DELETE: 'delete',
    SEARCH: 'search',
};
FIELDS.ITEMS = {
    CREATE_ITEM: 'createItem',
    ITEM_NAME: 'item_name',
    WEIGHT: 'weight',
    PRICE: 'price',
    RECIPE_QTY: 'recipeQty',
    PCS: 'pcs',
    PCS_TITLE: 'pcs_Title',
    COUNT: 'count',
    CREATE_NEW_ITEM: 'create_new_item',
    CREATE_NEW_ITEM_DIALOG_CONT: 'create_new_item_dialog_cont',
    UNIT_OF_WEIGHT: 'unit_of_weight',
    MODIFIED_ITEM: 'modified_item',
    RENAME_ITEM: 'rename_item',
    RENAME_ITEM_DIALOG_CONT: 'rename_item_dialog_cont',
    ADD_STOCK: 'add_stock',
    WEIGHT_OF_PIECE: 'weight_of_piece',
    DELETE_ITEM: 'delete_item',
    DELETE_ITEM_INFO_START: 'delete_item_info_start',
    DELETE_ITEM_INFO_START_MOBILE: 'delete_item_info_start_mobile',
    NUM_SELECTED: 'numSelected',
    BACK_TO_ITEMS: 'back_to_Items',
    ITEMS: 'items',
    PACKAGING: 'packaging',
    LOGIN_TITLE: 'loginTitle',
    LOGIN_BTN: 'loginBtn',
    EMAIL_HOLDER: 'emailHolder',
    PSW_HOLDER: 'pswHolder',
    LOGIN_ERROR: 'loginError',
    SERVER_ERROR: 'serverError',
};
FIELDS.MENU = {
    PROFILE: 'profile',
    ORDERS: 'orders',
    DELIVERY: 'delivery',
    STOCK: 'stock',
    FINANCE: 'finance',
    SETTINGS: 'settings',
    LOGOUT: 'logout',
};
FIELDS.RECIPES = {
    BACK_TO_RECIPES: 'back_to_recipes',
    CREATE_RECIPE: 'create_recipe',
    BACK_TO_FILLINGS: 'back_to_fillings',
    CREATE_FILLING: 'create_filling',
    CREATE_NON_LINEAR_RECIPE: 'create_non_linear_recipe',
    DESCRIPTION: 'description',
    RECIPE_COST: 'recipe_cost',
    RECIPE_NAME: 'recipe_name',
    SAVE_RECIPE: 'save_recipe',
    SAVE_RECIPE_SHORT: 'save_recipe_short',
    ADD_PART: 'add_part',
    ADD_PART_DEFAULT: 'add_part_default',
    ADD_PROPORTION: 'add_proportion',
    ADD_PROPORTION_SHORT: 'add_proportion_short',
    DEFAULT_PROPORTION_1: 'default_proportion_1',
    DEFAULT_PROPORTION_2: 'default_proportion_2',
    DELETE_PART: 'delete_part',
    PART_NAME: 'part_name',
    ADDITIONAL_INFO: 'additional_info',
    ADD_ADDITIONAL_INFO: 'add_additional_info',
    ADD_NEW_ITEM: 'add_new_item',
    ITEM_NAME_RECIPES: 'item_name_recipes',
    COUNT_RECIPES: 'count_recipes',
    DELETE_ITEM_PART: 'delete_item_part',
    RESTORE_ITEM_PART: 'restore_item_part',
    ADD_ITEM_PART: 'add_item_part',
    ADD_ITEM_PART_SHORT: 'add_item_part_short',
    SERVICE_SIZE: 'service_size',
    SERVICE_PRICE: 'service_price',
    EDIT_RECIPE: 'edit_recipe',
    CANCEL_EDITING: 'cancel_editing',
    PART: 'part',
    RECIPE: 'recipe',
    RECIPES: 'recipes',
    RESTORE_I: 'restore_i',
    DELETE_I: 'delete_i',
    LINEAR_RECIPE: 'linear_recipe',
    NONLINEAR_RECIPE: 'nonlinear_recipe',
    DELETE_TITLE: 'delete_title',
    CONFIRM_DELETION: 'confirm_deletion',
    USED_IN_RECIPES: 'used_in_recipes',
    USED_IN_FILLINGS: 'used_in_fillings',
    FILLING: 'filling',
    EDIT_FILLING: 'edit_filling',
    ADD_RELATIVE_RECIPE: 'add_relative_recipe',
    SAVE_FILLING: 'save_filling',
    RELATIVE_RECIPES: 'relative_recipes',
    FILLING_NAME: 'filling_name',
};
FIELDS.ORDERS = {
    HAS_REVIEW: 'has_review',
    CREATE_ORDER: 'create_order',
    DELETE_ORDER: 'delete_order',
    DELETE_ORDER_MESSAGE: 'delete_order_message',
    DELETE_ORDER_BY_CUSTOMER_MESSAGE: 'delete_order_by_customer_message',
    RECEIPT_ISSUED: 'receipt_issued',
    BACK_TO_ORDER_LIST: 'back_to_order_list',
    ORDER_NUMBER: 'order_number',
    PRICE_ORDERS: 'price_orders',
    DESCRIPTION_ORDERS: 'description_orders',
    PREPAYMENT: 'prepayment',
    WAITING: 'waiting',
    RECEIVED: 'received',
    ORDER_SOURCE: 'order_source',
    CUSTOMER: 'customer',
    CUSTOMER_INFO: 'customer_info',
    MORE_INFO: 'more_info',
    PICK_UP_DATE: 'pick_up_date',
    PICK_UP_TIME: 'pick_up_time',
    REST_FOR_PAYMENT: 'rest_for_payment',
    CLOSE: 'close',
    SELECT: 'select',
    EDIT: 'edit',
    ORDER_DONE: 'order_done',
    PICKED_UP: 'picked_up',
    ORDER_DESCRIPTION: 'order_description',
    SEARCH_CUSTOMER: 'search_customer',
    CUSTOMERS: 'customers',
    FOUND_CUSTOMERS: 'foundCustomers',
    CREATE_CUSTOMER: 'create_customer',
    SELECTED_CUSTOMER: 'selected_customer',
    NO_CUSTOMER: 'no_customer',
    CUSTOMER_NOT_FOUND: 'customer_not_found',
    ADD_SUBORDER: 'add_suborder',
    DELETE_SUBORDER: 'delete_suborder',
    SUB_ORDERS: 'sub_orders',
    EDIT_SUB_ORDERS: 'edit_sub_orders',
    TOTAL_ORDER_PRICE: 'total_order_price',
    TOTAL_ORDER_COST: 'total_order_cost',
    TOTAL_ORDER_PROFIT: 'total_order_profit',
    ORDER_PRICE: 'order_price',
    ORDER_COST: 'order_cost',
    ORDER_PROFIT: 'order_profit',
    SAVE_ORDER: 'save_order',
    SELECT_RECIPE: 'select_recipe',
    RECIPE_SIZE_KG: 'recipe_size_kg',
    RECIPE_PROPORTION: 'recipe_proportion',
    COUNT_ORDERS: 'count_orders',
    BACK_TO_ORDERS: 'back_to_orders',
    PREPAYMENT_BALANCE: 'prepayment_balance',
    PREPAYMENT_AT: 'prepayment_at',
    CHANGE_PICKUP_DATE: 'change_pickup_date',
    CHANGE_PREPAYMENT: 'change_prepayment',
    RECIPE_TITLE: 'recipe_title',
    FILLING_TITLE: 'filling_title',
    FULL_NAME: 'full_name',
    EMAIL: 'email',
    PHONE_NUMBER: 'phone_number',
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    REQUIRED_INGREDIENTS: 'required_ingredients',
    SELECT_DATES_FOR_THE_SEARCH: 'select_dates_for_the_search',
    SELECT_DATE_RANGE_FOR_THE_SEARCH: 'select_date_range_for_the_search',
    OPEN_CALENDAR: 'open_calendar',
    CLOSED_ORDERS: 'closed_orders',
    BY_RECIPE_NAME: 'by_recipe_name',
    RANGE_SEARCH: 'range_search',
    MULTIPLE_DATES_SEARCH: 'multiple_dates_search',
    SEARCH_OPTIONS: 'search_options',
    AN_ORDER_FOR_THE_CUSTOMER: 'an_order_for_the_customer',
    SHOW_ORDER: 'show_order',
    SUNDAY: 'sunday',
    MONDAY: 'monday',
    TUESDAY: 'tuesday',
    WEDNESDAY: 'wednesday',
    THURSDAY: 'thursday',
    FRIDAY: 'friday',
    SATURDAY: 'saturday',
    SEARCHED_ORDER: 'searchedOrder',
    NO_RECORDS: 'no_records',
    UPLOAD_TARGET_IMAGES: 'upload_target_images',
};
FIELDS.CUSTOMERS = {
    CUSTOMER_NAME: 'customer_name',
    CUSTOMER_QTY: 'customer_qty',
    BACK_TO_CUSTOMERS: 'back_to_customers',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    PHONE_NUMBER: 'phoneNumber',
};
FIELDS.NAV_BAR = {
    FINANCES: 'finances',
    RECIPES: 'recipes',
    RECIPES_FILLINGS: 'recipes_fillings',
    RECIPES_DECORATIONS: 'recipes_decorations',
    ITEMS: 'items',
    CUSTOMERS_NAVBAR: 'customers_navbar',
    ORDERS_NAVBAR: 'orders_navbar',
    HOME: 'home',
    SCREEN_RESOLUTION: 'screenResolution',
};
FIELDS.HOME_PAGE = {
    INCOME: 'income',
    OUTCOME: 'outcome',
    DELTA: 'delta',
    WEEK_STATS: 'weekStats',
    MONTH_STATS: 'monthStats',
    PREV_MONTH: 'prevMonth',
    PREV_WEEKS: 'prevWeeks',
    NEXT_MONTH: 'nextMonth',
    NEXT_WEEKS: 'nextWeeks',
    HOME_PAGE_INFO_ONE: 'home_page_info_one',
    HOME_PAGE_INFO_TWO: 'home_page_info_two',
};
FIELDS.PRODUCT_TYPE = {
    PRODUCT_TYPE: 'productType'
};
FIELDS.PACKAGES = {
    PACKAGES: 'packages',
};
FIELDS.SETTINGS = {
    ADD_PRODUCT_TYPE: 'addProductType',
    SELECT_PACKAGES: 'selectPackages',
    SELECT_RECIPES: 'selectRecipes',
    NOT_AVAILABLE_PACKAGES: 'notAvailablePackages',
    NOT_SELECTED_PACKAGES: 'notSelectedPackages',
    NOT_AVAILABLE_RECIPES: 'notAvailableRecipes',
    NOT_SELECTED_RECIPES: 'notSelectedRecipes',
    CREATE_NEW_PRODUCT_TYPE: 'createNewProductType',
    PRODUCT_TYPE_NAME: 'productTypeName',
};
